import React from 'react';
import { Grid, Typography, ButtonGroup, Table, TableBody } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { WhiteCard } from 'components/styles_components/card';
import ShowItemTableRow from 'components/item/show_item_table_row';
import Place from 'utils/place';
import EditButton from 'components/place/button/edit';
import DeleteButton from 'components/place/button/delete';
import GoogleLinkButton from 'components/navigation/google_link_button';
import FileSection from 'components/file/section';
import UploadPlaceFileMutation from 'mutations/external_file/upload_place_file';

const ShowItem = ({ place, space, refetch }) => {
  return (
    <>
      <WhiteCard className={Place(place).htmlClass}>
        <Typography variant="h5">{place.name}</Typography>
        <Grid container direction="row" justifyContent="space-between" spacing={2}>
          <Table sx={{ mt:2, mb: 2 }}>
            <TableBody>
              <ShowItemTableRow label={<FormattedMessage id="place.street" />}>{place.street}</ShowItemTableRow>
              <ShowItemTableRow label={<FormattedMessage id="place.zip_code" />}>
                {place.zipCode}
              </ShowItemTableRow>
              <ShowItemTableRow label={<FormattedMessage id="place.city" />}>{place.city}</ShowItemTableRow>
              <ShowItemTableRow label={<FormattedMessage id="inspection.overdue.count" />}>
                {place.overdueInspectionsTotal}
              </ShowItemTableRow>
              <ShowItemTableRow label={<FormattedMessage id="inspection.incoming.count" />}>
                {place.incomingInspectionsTotal}
              </ShowItemTableRow>
            </TableBody>
          </Table>
          <Grid size={{ xs: 12 }} textAlign="right">
            <ButtonGroup variant="contained">
              <GoogleLinkButton place={place} />
              {space.adminRole && <EditButton place={place} space={space} refetch={refetch} />}
              {space.adminRole && <DeleteButton place={place} space={space} />}
            </ButtonGroup>
          </Grid>
        </Grid>
      </WhiteCard>
      <FileSection
        files={place.externalFiles}
        uploadMutation={UploadPlaceFileMutation}
        uploadVariables={{ placeId: place.id }}
        refetch={refetch}
        canUpload={space.adminRole}
      />
    </>
  );
};

export default ShowItem;
